import { Navigate } from 'react-router-dom';
import { ROUTES } from '@/config/app.config';
import { useAuthStore } from '@/stores/use-auth-store';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
    const { isAuthenticated } = useAuthStore();

    if (!isAuthenticated) {
        return <Navigate to={ROUTES.login} replace />;
    }

    return <>{children}</>;
}

export default ProtectedRoute;
